import React from "react";
import "./MobileDescPromises.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { services } from "../../data";

function MobileDescPromises({ selectProduct }) {
  const settings = {
    // dots: true,
    infinite: true,
    speed: 650,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    vertical: false,
    arrows: false,
  };

  // Conditionally slice services
  const filteredServices =
    selectProduct && selectProduct[0]?.Manufacturer === "GARRARI BIKES"
      ? services.slice(2, 4)
      : services;

  return (
    <div className="mobile-servicePromices-container">
      <Slider {...settings}>
        {filteredServices?.map((data, index) => (
          <div className="mobile-servicePromices" key={index}>
            <img loading="lazy" src={data.icon} alt="" />
            <div className="mobile-servicePromices-text">
              <span className="mobile-servicePromices-heading">
                {data.heading}
              </span>
              <div className="mobile-servicePromices-desc">{data.desc}</div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default MobileDescPromises;
